import {getCookie} from 'common/util/cookie';

const csrfSafeMethod = (method) => /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
const isSameOrigin = (url) =>
  url.startsWith(`/`) || (url.startsWith(`https://`) && window.location.origin === new URL(url).origin);

// don't double patch fetch
if (!window[`_fetch`]) {
  const csrfToken = getCookie(`csrftoken`);

  if (window[`$`]) {
    // jquery hook, if jquery is present
    $.ajaxSetup({
      beforeSend(xhr, settings) {
        if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
          xhr.setRequestHeader(`X-CSRFToken`, csrfToken);
          xhr.setRequestHeader(`X-Requested-With`, `XMLHttpRequest`);
        }
      },
    });
  }

  // patch window.fetch to always send X-CSRF header on same-origin requests that can modify resources
  const _fetch = (window[`_fetch`] = window.fetch);
  window.fetch = function (url, options = {}) {
    const method = options && options.method;
    // same-origin check so we're not sending csrf tokens to non mixpanel.com domains
    if (!csrfSafeMethod(method) && isSameOrigin(url)) {
      const headers = {...options.headers, 'X-CSRFToken': csrfToken};
      options = {...options, headers, credentials: `same-origin`};
    }
    return _fetch(url, options);
  };
}
